import { Button, Spinner, Form, Row, Col, Card, Badge } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Global.css';
import Navbar from '../components/Navbar';
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import api from '../api';

function TournamentDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem('JWTTOKEN');

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    // Hata ve başarı mesajları için state'ler
    const [errorMsg, setErrorMsg] = useState(null);
    const [successMsg, setSuccessMsg] = useState(null);

    const getTournament = async () => {
        try {
            const res = await api.get(`/v1/tournament/id/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setData(res.data.data);
        } catch (err) {
            console.error("Veri çekme hatası:", err);
            setErrorMsg("Turnuva yüklenirken bir hata oluştu. Lütfen bağlantınızı kontrol edin.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!token) {
            navigate("/login");
            return;
        }
        getTournament();
    }, [id, token, navigate]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDecisionChange = (index, field, value) => {
        const updatedDecisions = [...data.decisions];
        updatedDecisions[index][field] = value;

        setData((prev) => ({
            ...prev,
            decisions: updatedDecisions
        }));
    };

    const handleSave = async () => {
        setSaving(true);
        setErrorMsg(null);
        setSuccessMsg(null);

        try {
            await api.put(`/v1/tournament/${id}`, data, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setSuccessMsg("Turnuva başarıyla güncellendi!");

            // 3 saniye sonra başarı mesajını ekrandan kaldır
            setTimeout(() => {
                setSuccessMsg(null);
            }, 3000);

        } catch (err) {
            console.error("Kaydetme hatası:", err);
            setErrorMsg("Kaydedilirken bir hata oluştu. Sunucu bağlantısını kontrol edin.");
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="app-container d-flex" style={{ backgroundColor: '#0a0a0a', minHeight: '100vh' }}>
                <Navbar />
                <div className="main-content flex-grow-1 d-flex justify-content-center align-items-center">
                    <Spinner animation="border" variant="light" />
                </div>
            </div>
        );
    }

    // Veri gelmediyse ve yükleme bittiyse sadece hata mesajını göster
    if (!data && errorMsg) {
        return (
            <div className="app-container d-flex" style={{ backgroundColor: '#0a0a0a', minHeight: '100vh' }}>
                <Navbar />
                <div className="main-content flex-grow-1 p-4 d-flex justify-content-center align-items-center">
                    <div className="p-3" style={{ backgroundColor: '#ff4d4d20', color: '#ff4d4d', borderRadius: '8px', border: '1px solid #ff4d4d' }}>
                        {errorMsg}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="app-container d-flex" style={{ backgroundColor: '#0a0a0a', minHeight: '100vh' }}>
            <Navbar />

            <div className="main-content flex-grow-1 p-4 p-md-5" style={{ overflowY: 'auto', height: '100vh' }}>

                {/* Üst Kısım: Başlık ve Butonlar */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <Button variant="link" style={{ color: '#8b8b8b', padding: 0, textDecoration: 'none' }} onClick={() => navigate(-1)}>
                            ← Geri Dön
                        </Button>
                        <h2 style={{ color: 'white', margin: '10px 0 0 0' }}>Turnuva Düzenle</h2>
                        <span style={{ color: '#8b8b8b', fontSize: '14px' }}>ID: {data._id}</span>
                    </div>
                    <Button
                        variant="success"
                        onClick={handleSave}
                        disabled={saving}
                        style={{ fontWeight: '600', backgroundColor: '#029220', border: 'none', minWidth: '120px' }}
                    >
                        {saving ? <Spinner size="sm" animation="border" /> : "Değişiklikleri Kaydet"}
                    </Button>
                </div>

                {/* Ekrana Yazdırılan Hata ve Başarı Mesajları Alanı */}
                {errorMsg && (
                    <div className="mb-4 p-3" style={{ backgroundColor: '#ff4d4d20', color: '#ff4d4d', borderRadius: '8px', border: '1px solid #ff4d4d' }}>
                        {errorMsg}
                    </div>
                )}

                {successMsg && (
                    <div className="mb-4 p-3" style={{ backgroundColor: '#02922020', color: '#02bd2a', borderRadius: '8px', border: '1px solid #029220' }}>
                        {successMsg}
                    </div>
                )}

                <Row className="g-4">
                    {/* Sol Kolon: Genel Bilgiler */}
                    <Col xs={12} lg={6}>
                        <Card style={{ backgroundColor: '#121212', border: '1px solid #252525', borderRadius: '12px' }}>
                            <Card.Body>
                                <h5 style={{ color: 'white', marginBottom: '20px', borderBottom: '1px solid #252525', paddingBottom: '10px' }}>
                                    Genel Bilgiler
                                </h5>
                                <Form>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={{ color: '#8b8b8b' }}>Başlık (Title)</Form.Label>
                                                <Form.Control type="text" name="title" value={data.title || ''} onChange={handleInputChange} className="dark-input" />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={{ color: '#8b8b8b' }}>Kategori</Form.Label>
                                                <Form.Control type="text" name="category" value={data.category || ''} onChange={handleInputChange} className="dark-input" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={{ color: '#8b8b8b' }}>Slug</Form.Label>
                                                <Form.Control type="text" name="slug" value={data.slug || ''} onChange={handleInputChange} className="dark-input" />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={{ color: '#8b8b8b' }}>Durum (Status)</Form.Label>
                                                <Form.Select name="status" value={data.status || 'waiting'} onChange={handleInputChange} className="dark-input">
                                                    <option value="verified">Verified</option>
                                                    <option value="waiting">Waiting</option>
                                                    <option value="denied">Denied</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={{ color: '#8b8b8b' }}>Görünürlük (Visibility)</Form.Label>
                                                <Form.Select name="visibility" value={data.visibility || 'unlisted'} onChange={handleInputChange} className="dark-input">
                                                    <option value="public">Public</option>
                                                    <option value="unlisted">Unlisted</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={{ color: '#8b8b8b' }}>Kapak Görseli Linki (Image URL)</Form.Label>
                                                <Form.Control type="text" name="image" value={data.image || ''} onChange={handleInputChange} className="dark-input" />
                                            </Form.Group>
                                        </Col>

                                        {/* Salt okunur istatistikler */}
                                        <Col md={12} className="mt-3">
                                            <div className="d-flex gap-3">
                                                <Badge bg="dark" style={{ border: '1px solid #444', padding: '8px 12px' }}>Oynanma: {data.playCount}</Badge>
                                                <Badge bg="dark" style={{ border: '1px solid #444', padding: '8px 12px' }}>Oluşturan: {data.createdBy}</Badge>
                                                <Badge bg="dark" style={{ border: '1px solid #444', padding: '8px 12px' }}>Dil: {data.language.toUpperCase()}</Badge>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>

                            <img src={data.image} alt="Turnuva Kapak Görseli" style={{ height: 500,  objectFit: 'cover' }} />
                        </Card>
                    </Col>

                    {/* Sağ Kolon: Yarışmacılar (Decisions) */}
                    <Col xs={12} lg={6}>
                        <Card style={{ backgroundColor: '#121212', border: '1px solid #252525', borderRadius: '12px', height: '100%' }}>
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-center mb-3" style={{ borderBottom: '1px solid #252525', paddingBottom: '10px' }}>
                                    <h5 style={{ color: 'white', margin: 0 }}>Decisions</h5>
                                    <Badge bg="secondary">{data.decisions?.length || 0} Decision</Badge>
                                </div>

                                <div style={{ maxHeight: '900px', overflowY: 'auto', paddingRight: '5px' }}>
                                    {data.decisions && data.decisions.length > 0 ? (
                                        data.decisions.map((decision, index) => (
                                            <div key={index} className="mb-3 p-3" style={{ backgroundColor: '#0d0d0d', borderRadius: '8px', border: '1px solid #252525' }}>
                                                <div className="d-flex gap-3">
                                                    {/* Küçük Önizleme Görseli */}
                                                    <div style={{ width: '60px', height: '60px', flexShrink: 0, backgroundColor: '#252525', borderRadius: '6px', overflow: 'hidden' }}>
                                                        {decision.image ? (
                                                            <img src={decision.image} alt={decision.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                        ) : (
                                                            <div className="d-flex h-100 justify-content-center align-items-center text-muted" style={{ fontSize: '10px' }}>No Img</div>
                                                        )}
                                                    </div>

                                                    {/* Inputlar */}
                                                    <div className="flex-grow-1">
                                                        <Form.Group className="mb-2">
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                placeholder="Yarışmacı İsmi"
                                                                value={decision.title || ''}
                                                                onChange={(e) => handleDecisionChange(index, 'title', e.target.value)}
                                                                className="dark-input"
                                                            />
                                                        </Form.Group>
                                                        <Form.Group>
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                placeholder="Resim URL'si"
                                                                value={decision.image || ''}
                                                                onChange={(e) => handleDecisionChange(index, 'image', e.target.value)}
                                                                className="dark-input"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p style={{ color: '#8b8b8b' }}>Bu turnuvada yarışmacı bulunmuyor.</p>
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default TournamentDetails;